import canUseDOM from './canUseDOM'

export const getServerSideURL = () => {
  let url = process.env.NEXT_PUBLIC_SERVER_URL

  if (!url) {
    url = 'https://containercity.net'
  }

  return url
}

export const getClientSideURL = () => {
  if (canUseDOM) {
    const protocol = window.location.protocol
    const domain = window.location.hostname
    const port = window.location.port

    return `${protocol}//${domain}${port ? `:${port}` : ''}`
  }

  if (process.env.NEXT_PUBLIC_SERVER_URL) {
    return `https://${process.env.NEXT_PUBLIC_SERVER_URL}` 
  }

  return process.env.NEXT_PUBLIC_SERVER_URL || 'https://containercity.net'
}
